type RangeElement = number | [number, number];

export const parseRange = (range: string): RangeElement[] => {
  return range.split(",").map(element => {
    if (element.includes("..")) {
      const [min, max] = element.split("..").map(Number);
      return [min, max] as [number, number];
    }
    return Number(element);
  });
};

export const findClosestNumber = (parsedRange: RangeElement[], value: number): number => {
  let closest = Infinity;

  for (const element of parsedRange) {
    if (Array.isArray(element)) {
      const [min, max] = element;
      if (value >= min && value <= max) {
        return value;
      }
      const closestInThisRange = Math.abs(min - value) < Math.abs(max - value) ? min : max;
      closest = Math.abs(closest - value) < Math.abs(closestInThisRange - value) ? closest : closestInThisRange;
    } else {
      if (value === element) {
        return value;
      }
      closest = Math.abs(closest - value) < Math.abs(element - value) ? closest : element;
    }
  }

  return closest;
};
